<template>
  <publicImport :importTypeList="importTypeList"></publicImport>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import publicImport from "@/components/common/publicImport";

export default {
  name: "importTask",
  data() {
    return {
      importTypeList: [
        {value: 'productImport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000838')},
        {value: 'inventoryImport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000890')},
        {value: 'productGoodsSuggestPriceImport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003365')},
        {value: 'productGoodsStatusImport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006973')},
        {value: 'importSupplierStockOrder', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005610')},
      ]
    };
  },
  components: {
    publicImport
  }
};
</script>
<style scoped>

</style>
